import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getId() {
  return Cookies.get('userId') || localStorage.getItem('userId')
}

export function setId(id) {
  Cookies.set('userId', id)
  localStorage.setItem('userId', id)
}

export function removeId() {
  Cookies.remove('userId')
  localStorage.removeItem('userId')
}
